export const filterReservationdata = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'booked', list: 'Booked', key: 'Status' },
      { value: 'alloted', list: 'Alloted', key: 'Status' },
      { value: 'dispatched', list: 'Dispatched', key: 'Status' },
      { value: 'onGoing', list: 'Ongoing', key: 'Status' },
      { value: 'completed', list: 'Completed', key: 'Status' },
      { value: 'cancelled', list: 'Cancelled', key: 'Status' },
      { value: 'billed', list: 'Billed', key: 'Status' },
    ],
  },
];

export function reservationFormData(
  dutyTypeOption,
  carOption,
  companyList,
  employeeList,
  selectedCompanyDetails,
  isEdit,
  cityOption,
  companyBranches
) {
  return {
    bookingCompany: [
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Company Name',
        type: 'text',
        name: 'companyId',
        label: 'Company Name',
        optionData: companyList || [],
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: 'Enter Parent Company Name',
        required: false,
        name: 'parentCompany',
        label: 'Parent Company Name',
        type: 'text',
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: 'Enter Email ID',
        required: false,
        type: 'email',
        name: 'companyEmail',
        label: 'Email ID',
        fieldDisabled: true,
      },
      {
        fileUpload: true,
        required: true,
        gridSize: 4,
        name: 'InsuranceFile',
        label: 'Upload Email',
        placeholder: 'Upload Email',
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
      },
    ],
    travellerDetails: [
      !isEdit && {
        radio: true,
        required: true,
        gridSize: 12,
        name: 'travellerDetails',
        values: [
          {
            value: 'new user',
            label: 'New User',
          },
          {
            value: 'existing User',
            label: 'Existing User',
          },
          {
            value: 'guestUser',
            label: 'Guest Traveller',
          },
        ],
      },
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Email ID',
        type: 'email',
        name: 'employeeEmail',
        label: 'Email ID',
        optionData: employeeList || [],
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Name',
        type: 'text',
        name: 'employeeName',
        label: 'Name',
        star: '*',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: 'Enter your Phone Number',
        countrycode: true,
        type: 'number',
        name: 'employeePhoneNumber',
        label: 'Phone Number',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Employee ID',
        type: 'text',
        name: 'employeeCode',
        label: 'Employee ID',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Department/ Project Code/ Cost Code',
        type: 'text',
        name: 'departmentCode',
        label: 'Department/ Project Code/ Cost Code',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        star: '*',
        gridSize: 4,
        placeholder: 'Enter Branch Name',
        type: 'string',
        name: 'employeeBranch',
        label: 'Branch',
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        required: false,
        placeholder: 'Enter Travel Request No.',
        type: 'text',
        name: 'travelRequestNumber',
        label: 'Travel Request No.',
        fieldDisabled: isEdit,
      },
      {
        checkbox: true,
        name: 'isVip',
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: '1',
            name: 'isVip',
            checkboxLablel: 'VIP',
          },
        ],
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    dutyAndVehicle: [
      {
        reservationAutoComplete: true,
        gridSize: 6,
        required: true,
        star: '*',
        placeholder: 'Choose your City',
        type: 'text',
        name: 'location',
        label: 'City',
        optionData: cityOption,
        fieldDisabled: isEdit,
      },
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 6,
        placeholder: 'Choose your Duty Type',
        type: 'text',
        name: 'dutyTypeId',
        label: 'Duty Type',
        star: '*',
        optionData: dutyTypeOption,
        fieldDisabled: isEdit,
      },
       // NEW: show toggle next to Duty Type when Rental is selected
      {
        switch: true,
        name: 'multiDayBooking',
        required: false,
        gridSize: 6,
        showForDutyTypes: ['Rental'], // renders only when dutyType is Rental
        subItems: [
          {
            id: 'multiDayBooking',
            name: 'multiDayBooking',
            checkboxLablel: 'Multi-day booking',
          },
        ],
      },
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 6,
        placeholder: 'Choose your Vehicle Group',
        type: 'text',
        name: 'vehicleCategoryId',
        label: 'Vehicle Category',
        star: '*',
        optionData: carOption,
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        gridSize: 6,
        required: true,
        placeholder: 'Enter No. of Traveler',
        type: 'number',
        name: 'noOfTravelers',
        label: 'No. of Traveler',
        fieldDisabled: isEdit,
      },
      {
        guestDetails: true, // New field type
        gridSize: 12,
        name: 'guestDetails',
        label: 'Guest Details',
        conditionalField: 'noOfTravelers',
        fieldDisabled: isEdit,
      },
      {
        checkbox: true,
        name: 'needPlacard',
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: '1',
            name: 'needPlacard',
            checkboxLablel: 'Need Placard',
          },
        ],
      },
      {
        textField: true,
        gridSize: 12,
        multiline: true,
        rows: 2,
        placeholder: 'Enter Placard Text (25 characters per line)',
        type: 'text',
        name: 'placardText',
        label: 'Placard Text',
        maxLength: 50, // Total max length
        dependentField: 'needPlacard', // Show only when checkbox is checked
        validation: {
          validate: (value) => {
            if (!value) return true;
            const lines = value.split('\n');
            return !lines.some(line => line.length > 25) || 'Maximum 25 characters per line allowed';
          }
        }
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    tripDetails: [
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    tripNote: [
      {
        textField: true,
        gridSize: 12,
        multiline: true,
        placeholder: 'Add Special Instruction',
        type: 'text',
        name: 'note',
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    billingType: [{}],
  };
}

export const bookingFormBorder = {
  dashedBorder: 'dashedBorder',
  border: 'dashed',
};

//Airport Transfer form
export const toAirportForm = (terminalList, isEdit) => [
  {
    radio: true,
    required: true,
    type: 'text',
    name: 'airportRideType',
    values: [
      {
        value: 'To-Airport',
        label: 'To the Airport',
      },
      {
        value: 'From-Airport',
        label: 'From the Airport',
      },
    ],
    fieldDisabled: isEdit,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your Trip Date',
    type: 'date',
    name: 'scheduledTime',
    label: 'Date & Start Time',
    min: 'today',
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    placeholder: 'Enter your From Address',
    type: 'text',
    name: 'pickUp',
    label: 'From Address',
    clearOnBlur: false,
  },
  {
    google: true,
    gridSize: 6,
    placeholder: 'Enter your Landmark',
    type: 'text',
    name: 'landmark',
    label: 'Landmark',
    clearOnBlur: true,
    fieldDisabled: isEdit,
  },
  {
    options: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your To Address',
    name: 'toAirportTerminal',
    label: 'To Address',
    menuOptions: terminalList,
  },
  {
    textField: true,
    gridSize: 6,
    placeholder: 'Enter Airline Details',
    type: 'text',
    name: 'airlineDetails',
    label: 'Airlines Details',
    fieldDisabled: isEdit,
  },
  {
    textField: true,
    required: false,
    gridSize: 6,
    type: 'text',
    placeholder: 'Enter Fight Details',
    name: 'flightNo',
    label: 'Flight No',
    fieldDisabled: isEdit,
  },
  {
    dashedBorder: 'dashedBorder',
    border: 'dashed',
  },
];

export const fromAirportForm = (terminalList, isEdit) => [
  {
    radio: true,
    required: true,
    type: 'text',
    name: 'airportRideType',
    values: [
      {
        value: 'To-Airport',
        label: 'To the Airport',
      },
      {
        value: 'From-Airport',
        label: 'From the Airport',
      },
    ],
    fieldDisabled: isEdit,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your Trip Date',
    type: 'date',
    name: 'scheduledTime',
    label: 'Date & Start Time',
    min: 'today',
  },
  {
    options: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your From Address',
    name: 'fromAirportTerminal',
    label: 'From Address',
    menuOptions: terminalList,
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your To Address',
    type: 'text',
    name: 'drop',
    label: 'To Address',
    clearOnBlur: true,
    fieldDisabled: false,
  },
  {
    textField: true,
    gridSize: 6,
    placeholder: 'Enter Airline Details',
    type: 'text',
    name: 'airlineDetails',
    label: 'Airlines Details',
    fieldDisabled: isEdit,
  },
  {
    textField: true,
    required: true,
    gridSize: 6,
    type: 'text',
    placeholder: 'Enter Fight Details',
    name: 'flightNo',
    label: 'Flight No',
    fieldDisabled: isEdit,
  },
  {
    dashedBorder: 'dashedBorder',
    border: 'dashed',
  },
];

//Rental Form
export const RentalFields = (rateCardPackage, isEdit, isMultiDay=false) => [
  {
    options: true,
    gridSize: 6,
    required: isEdit || isMultiDay ? false : true,
    star: '*',
    placeholder: 'Choose Package Type',
    name: 'package',
    label: 'Slab ',
    menuOptions: rateCardPackage,
    fieldDisabled: isEdit || isMultiDay,
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    placeholder: 'Enter your From Address',
    type: 'text',
    name: 'pickUp',
    label: 'From Address',
    clearOnBlur: false,
    
  },
  {
    google: true,
    gridSize: 6,
    placeholder: 'Enter your Landmark',
    type: 'text',
    name: 'landmark',
    label: 'Landmark',
    clearOnBlur: true,
    fieldDisabled: isEdit,
  },
  {
    google: true,
    gridSize: 6,
    placeholder: 'Enter your To Address',
    type: 'text',
    name: 'drop',
    label: 'To Address',
    clearOnBlur: true,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your Trip Date',
    type: 'date',
    name: 'scheduledTime',
    label: 'Date & Start Time',
    min: 'today',
  },
    // NEW: End Date & Time shown only when multiDayBooking is selected
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your End Date & Time',
    type: 'date',
    name: 'endDateTime',
    label: 'End Date & Time',
    min: 'today',
    dependentField: 'multiDayBooking',
  },
  {
    dashedBorder: 'dashedBorder',
    border: 'dashed',
  },
];

//Outstation Form
export const outstationFields = (isEdit) => [
  {
    google: true,
    gridSize: 6,
    required: true,
    placeholder: 'Enter your From Address',
    type: 'text',
    name: 'pickUp',
    label: 'From Address',
    clearOnBlur: false,
  },
  {
    google: true,
    gridSize: 6,
    placeholder: 'Enter your Landmark',
    type: 'text',
    name: 'landmark',
    label: 'Landmark',
    clearOnBlur: true,
    fieldDisabled: isEdit,
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your To Address',
    type: 'text',
    name: 'drop',
    label: 'To Address',
    clearOnBlur: true,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your Trip Date',
    type: 'date',
    name: 'scheduledTime',
    label: 'Start Date & Time ',
    min: 'today',
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: '*',
    placeholder: 'Enter your Trip Date',
    type: 'date',
    name: 'returnDate',
    label: 'Return Date & Time',
    min: 'today',
  },
  {
    dashedBorder: 'dashedBorder',
    border: 'dashed',
  },
];

export const billingDetails = (billingType, isEdit) => {
  const handleBillingType = (billingType) => {
    switch (Number(billingType)) {
      case 1:
        return [
          {
            value: 'billToIndividual',
            label: 'Bill to Credit Card',
          },
        ];
      case 2:
        return [
          {
            value: 'billToCompany',
            label: 'Bill to company',
          },
        ];
      case 3:
        return [
          {
            value: 'billToIndividual',
            label: 'Bill to Credit Card',
          },
          {
            value: 'billToCompany',
            label: 'Bill to company',
          },
        ];
      default:
        return '';
    }
  };

  return {
    radio: handleBillingType(billingType) && true,
    required: true,
    gridSize: 12,
    name: 'billingType',
    values: handleBillingType(billingType),
    fieldDisabled: isEdit,
  };
};

export const userOption = (employeeList) => {
  const existingUser = (employeeList) => {
    return {
      reservationAutoComplete: true,
      required: true,
      gridSize: 4,
      placeholder: 'Enter Email ID',
      type: 'email',
      name: 'employeeEmail',
      label: 'Email ID',
      optionData: employeeList || [],
    };
  };

  const newUser = {
    textField: true,
    required: true,
    star: '*',
    gridSize: 4,
    placeholder: 'Enter Email ID',
    type: 'string',
    name: 'newEmployee',
    label: 'Email ID',
  };

  const guestUser = {
    textField: true,
    required: false,
    gridSize: 4,
    placeholder: 'Enter Email ID',
    type: 'email',
    name: 'email',
    label: 'Email ID',
  };

  const guestDepartmentCode = 
  {
    textField: true,
    required: false,
    gridSize: 4,
    placeholder: 'Enter Department/ Project Code/ Cost Code',
    type: 'text',
    name: 'departmentCode',
    label: 'Department/ Project Code/ Cost Code',
  }
 const employeeCode = {
  textField: true,
  required: true,
  gridSize: 4,
  placeholder: 'Enter Employee ID',
  type: 'text',
  name: 'employeeCode',
  label: 'Employee ID',
}

  return { existingUser, newUser,guestUser,guestDepartmentCode,employeeCode };
};

export const branchOption = (companyBranch, isEdit) => {
  const newBranch = (companyBranch) => {
    return {
      options: true,
      gridSize: 4,
      required: true,
      star: '*',
      placeholder: 'Choose your Branch',
      name: 'newBranch',
      label: 'Branch',
      menuOptions: companyBranch,
      fieldDisabled: isEdit,
    };
  };

  const existingBranch = {
    textField: true,
    required: true,
    star: '*',
    gridSize: 4,
    placeholder: 'Enter Branch Name',
    type: 'string',
    name: 'employeeBranch',
    label: 'Branch',
    fieldDisabled: true,
  };

  return { newBranch, existingBranch };
};

export const reservationEditFormData = (
  companyList,
  employeeList,
  isEdit,
  bookingType,
  selectedCompanyDetails,
  guestTraveller
) => {
  
  return {
    bookingCompany: [
      {
        textField: true,
        gridSize: 4,
        placeholder: 'Choose Company Name',
        required: true,
        name: 'companyId',
        label: 'Company Name',
        type: 'text',
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: 'Enter Parent Company Name',
        required: false,
        name: 'parentCompany',
        label: 'Parent Company Name',
        type: 'text',
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: 'Enter Email ID',
        required: false,
        type: 'email',
        name: 'companyEmail',
        label: 'Email ID',
        fieldDisabled: true,
      },
      bookingType === 2 && {
        fileUpload: true,
        required: true,
        gridSize: 4,
        name: 'InsuranceFile',
        label: 'Upload Email',
        placeholder: 'Upload Email',
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
      },
    ],
    travellerDetails: guestTraveller
    ?[
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Email ID',
        type: 'email',
        name: 'employeeEmail',
        label: 'Email ID',
        optionData: employeeList || [],
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Name',
        type: 'text',
        name: 'employeeName',
        label: 'Name',
        star: '*',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter your Phone Number',
        countrycode: true,
        type: 'number',
        name: 'phoneNumber',
        label: 'Phone Number',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: false,
        gridSize: 4,
        placeholder: 'Enter Department/ Project Code/ Cost Code',
        type: 'text',
        name: 'departmentCode',
        label: 'Department/ Project Code/ Cost Code',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        star: '*',
        gridSize: 4,
        placeholder: 'Enter Branch Name',
        type: 'string',
        name: 'employeeBranch',
        label: 'Branch',
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        required: false,
        placeholder: 'Enter Travel Request No.',
        type: 'text',
        name: 'travelRequestNumber',
        label: 'Travel Request No.',
        fieldDisabled: isEdit,
      },
      {
        checkbox: true,
        name: 'isVip',
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: '1',
            name: 'isVip',
            checkboxLablel: 'VIP',
          },
        ],
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ]:[
      !isEdit && {
        radio: true,
        required: true,
        gridSize: 12,
        name: 'travellerDetails',
        values: [
          {
            value: 'new user',
            label: 'New User',
          },
          {
            value: 'existing User',
            label: 'Existing User',
          },
        ],
      },
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Email ID',
        type: 'email',
        name: 'employeeEmail',
        label: 'Email ID',
        optionData: employeeList || [],
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Name',
        type: 'text',
        name: 'employeeName',
        label: 'Name',
        star: '*',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter your Phone Number',
        countrycode: true,
        type: 'number',
        name: 'phoneNumber',
        label: 'Phone Number',
        fieldDisabled: isEdit,
      },

      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Employee ID',
        type: 'text',
        name: 'employeeCode',
        label: 'Employee ID',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: 'Enter Department/ Project Code/ Cost Code',
        type: 'text',
        name: 'departmentCode',
        label: 'Department/ Project Code/ Cost Code',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        star: '*',
        gridSize: 4,
        placeholder: 'Enter Branch Name',
        type: 'string',
        name: 'employeeBranch',
        label: 'Branch',
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        required: false,
        placeholder: 'Enter Travel Request No.',
        type: 'text',
        name: 'travelRequestNumber',
        label: 'Travel Request No.',
        fieldDisabled: isEdit,
      },
      {
        checkbox: true,
        name: 'isVip',
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: '1',
            name: 'isVip',
            checkboxLablel: 'VIP',
          },
        ],
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    dutyAndVehicle: [
      {
        textField: true,
        required: true,
        gridSize: 6,
        placeholder: 'Choose your City',
        type: 'text',
        name: 'location',
        label: 'City',
        star: '*',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        required: true,
        gridSize: 6,
        placeholder: 'Choose your Duty Type',
        type: 'text',
        name: 'dutyTypeId',
        label: 'Duty Type',
        star: '*',
        fieldDisabled: isEdit,
      },
      // NEW: show toggle next to Duty Type when Rental is selected
      {
        switch: true,
        name: 'multiDayBooking',
        required: false,
        gridSize: 6,
        showForDutyTypes: ['Rental'], // renders only when dutyType is Rental
        subItems: [
          {
            id: 'multiDayBooking',
            name: 'multiDayBooking',
            checkboxLablel: 'Multi-day booking',
          },
        ],
        fieldDisabled: isEdit, // Disable toggle in edit mode - it should retain the created value
      },
      {
        textField: true,
        required: true,
        gridSize: 6,
        placeholder: 'Choose your Vehicle Group',
        type: 'text',
        name: 'vehicleCategoryId',
        label: 'Vehicle Category',
        star: '*',
        fieldDisabled: isEdit,
      },
      {
        textField: true,
        gridSize: 6,
        required: true,
        placeholder: 'Enter No. of Traveler',
        type: 'number',
        name: 'noOfTravelers',
        label: 'No. of Traveler',
        fieldDisabled: isEdit,
      },
      {
        guestDetails: true,
        gridSize: 12,
        name: 'guestDetails',
        label: 'Guest Details',
        conditionalField: 'noOfTravelers',
        fieldDisabled: isEdit,
      },
      {
        checkbox: true,
        name: 'needPlacard',
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: '1',
            name: 'needPlacard',
            checkboxLablel: 'Need Placard',
          },
        ],
      },
      {
        textField: true,
        gridSize: 12,
        multiline: true,
        rows: 2,
        placeholder: 'Enter Placard Text (25 characters per line)',
        type: 'text',
        name: 'placardText',
        label: 'Placard Text',
        maxLength: 50, // Total max length
        dependentField: 'needPlacard', // Show only when checkbox is checked
        validation: {
          validate: (value) => {
            if (!value) return true;
            const lines = value.split('\n');
            return !lines.some(line => line.length > 25) || 'Maximum 25 characters per line allowed';
          }
        }
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    tripDetails: [
      // Start Date & Time - disabled in edit mode
      {
        dateTimePicker: true,
        gridSize: 6,
        required: true,
        star: '*',
        placeholder: 'Enter your Trip Date',
        type: 'date',
        name: 'scheduledTime',
        label: 'Date & Start Time',
        min: 'today',
        fieldDisabled: true, // Always disabled in edit mode
      },
      // End Date & Time shown only when multiDayBooking is selected and editable in edit mode
      {
        dateTimePicker: true,
        gridSize: 6,
        required: true,
        star: '*',
        placeholder: 'Enter your End Date & Time',
        type: 'date',
        name: 'endDateTime',
        label: 'End Date & Time',
        min: 'today',
        dependentField: 'multiDayBooking',
        fieldDisabled: false, // Enable editing end date in edit mode
      },
    ],
    tripNote: [
      {
        textField: true,
        gridSize: 12,
        multiline: true,
        placeholder: 'Add Special Instruction',
        type: 'text',
        name: 'note',
        fieldDisabled: isEdit,
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    billingType: [],
  };
};

export const tripStatusUpdateForm = (currentStatus) => {
  // Base options that are always available
  const baseOptions = [];
  
  // Add status options based on current status
  switch (currentStatus?.toLowerCase()) {
    case 'ongoing':
      baseOptions.push(
        { value: "Closed", label: "Closed" },
        { value: "Completed", label: "Completed" }
      );
      break;
    case 'closed':
      baseOptions.push(
        { value: "Completed", label: "Completed" }
      );
    break;
  }

  return [
    {
      id: 1,
      type: "select",
      label: "Status",
      name: "status",
      placeholder: "Select Status",
      required: true,
      options: baseOptions
    },
    {
      id: 2,
      type: "text",
      label: "Reason",
      name: "reason",
      placeholder: "Enter reason for status change",
      required: false
    }
  ];
};